import React from "react";
import "./FullScreenLoader.css"; // Import the CSS for styling

const FullScreenLoader = () => {
  return (
    <div className="fullscreen-loader">
      <div className="loader"></div>
    </div>
  );
};

export default FullScreenLoader;
